import { useNavigate } from "react-router-dom";

function Breadcrumb({ items, className = "" }) {
  const navigate = useNavigate();

  if (!items || !Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <nav
      className={`text-muted small mb-2 ${className}`}
      aria-label="breadcrumb"
    >
      <ol className="breadcrumb mb-0 d-flex flex-wrap align-items-center gap-1">
        {items.map((item, index) => {
          const link = item.path ?? item.href;
          const isLast = index === items.length - 1;
          const isClickable = link && link !== "#" && !isLast;

          return (
            <li
              key={index}
              className={`breadcrumb-item d-flex align-items-center ${
                isLast ? "active text-dark fw-medium" : ""
              }`}
              aria-current={isLast ? "page" : undefined}
            >
              {isClickable ? (
                <button
                  type="button"
                  className="btn btn-link p-0 border-0 align-baseline text-muted text-decoration-none small"
                  style={{
                    background: "none",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(link);
                  }}
                >
                  {item.label}
                </button>
              ) : (
                <span className={isLast ? "text-dark" : "text-muted"}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
